import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  SubHeader: `SubHeader`
};

export function useSubHeaderStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.SubHeader,
        {
          marginLeft: `11px`
        }
      ]
    }),
    []
  );
}
